import camelcase, { Options } from "camelcase";

export const pascalcase = (input: string | readonly string[], options?: Options): string =>
  camelcase(input, { pascalCase: true, preserveConsecutiveUppercase: true, ...options });
